module.exports = __webpack_public_path__ + "static/media/detailedHorseWhite.db959b7c.svg";